module.exports = __webpack_public_path__ + "media/logos/amazon-03cf9ccf.png";